// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=none"
// @generated from file building/v1/building.proto (package building.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file building/v1/building.proto.
 */
export const file_building_v1_building: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message building.v1.ClaimBuildingRequest
 */
export type ClaimBuildingRequest = Message<"building.v1.ClaimBuildingRequest"> & {
  /**
   * @generated from field: string building_id = 1;
   */
  buildingId: string;

  /**
   * @generated from field: string player_id = 2;
   */
  playerId: string;
};

/**
 * Describes the message building.v1.ClaimBuildingRequest.
 * Use `create(ClaimBuildingRequestSchema)` to create a new message.
 */
export const ClaimBuildingRequestSchema: GenMessage<ClaimBuildingRequest> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 0);

/**
 * @generated from message building.v1.ClaimBuildingResponse
 */
export type ClaimBuildingResponse = Message<"building.v1.ClaimBuildingResponse"> & {
  /**
   * @generated from field: building.v1.BuildingInfo building = 1;
   */
  building?: BuildingInfo | undefined;

  /**
   * @generated from field: int64 player_dirty_cash = 2;
   */
  playerDirtyCash: bigint;

  /**
   * @generated from field: int64 player_clean_influence = 3;
   */
  playerCleanInfluence: bigint;

  /**
   * @generated from field: int32 player_heat = 4;
   */
  playerHeat: number;
};

/**
 * Describes the message building.v1.ClaimBuildingResponse.
 * Use `create(ClaimBuildingResponseSchema)` to create a new message.
 */
export const ClaimBuildingResponseSchema: GenMessage<ClaimBuildingResponse> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 1);

/**
 * @generated from message building.v1.GetBuildingRequest
 */
export type GetBuildingRequest = Message<"building.v1.GetBuildingRequest"> & {
  /**
   * @generated from field: string building_id = 1;
   */
  buildingId: string;
};

/**
 * Describes the message building.v1.GetBuildingRequest.
 * Use `create(GetBuildingRequestSchema)` to create a new message.
 */
export const GetBuildingRequestSchema: GenMessage<GetBuildingRequest> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 2);

/**
 * @generated from message building.v1.BuildingInfo
 */
export type BuildingInfo = Message<"building.v1.BuildingInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string category = 3;
   */
  category: string;

  /**
   * @generated from field: string game_type = 4;
   */
  gameType: string;

  /**
   * @generated from field: double latitude = 5;
   */
  latitude: number;

  /**
   * @generated from field: double longitude = 6;
   */
  longitude: number;

  /**
   * @generated from field: string owner_player_id = 7;
   */
  ownerPlayerId: string;

  /**
   * @generated from field: string owner_faction = 8;
   */
  ownerFaction: string;

  /**
   * @generated from field: int32 influence = 9;
   */
  influence: number;

  /**
   * @generated from field: int32 tier = 10;
   */
  tier: number;

  /**
   * @generated from field: building.v1.BuildingStatus status = 11;
   */
  status: BuildingStatus;

  /**
   * Additional fields surfaced to clients.
   *
   * joined nickname; empty when unowned/no nickname
   *
   * @generated from field: string owner_player_name = 12;
   */
  ownerPlayerName: string;

  /**
   * @generated from field: int32 health = 13;
   */
  health: number;

  /**
   * @generated from field: string s2_cell = 14;
   */
  s2Cell: string;

  /**
   * @generated from field: optional int64 last_visited_at_unix_ms = 15;
   */
  lastVisitedAtUnixMs?: bigint | undefined;

  /**
   * @generated from field: optional int64 claimed_at_unix_ms = 16;
   */
  claimedAtUnixMs?: bigint | undefined;

  /**
   * @generated from field: int64 created_at_unix_ms = 17;
   */
  createdAtUnixMs: bigint;

  /**
   * Type-level economy attributes resolved server-side from
   * building_type_attributes (joined via game_type / building_type_aliases).
   * Zero means the building's game_type has no mapping (e.g. hospital).
   *
   * @generated from field: int64 base_reward = 18;
   */
  baseReward: bigint;

  /**
   * @generated from field: int32 base_influence = 19;
   */
  baseInfluence: number;

  /**
   * @generated from field: int32 base_heat = 20;
   */
  baseHeat: number;

  /**
   * Coarse map-marker hint: this building (by exact id or its game_type)
   * currently has enabled quests on offer. Same semantics as
   * NPCView.has_quests_available — enabled + in-window + level band;
   * per-player gates (prereqs, cooldowns) are excluded, the offer list
   * from QuestService.ListBuildingQuests is the per-player truth.
   *
   * @generated from field: bool has_quests_available = 21;
   */
  hasQuestsAvailable: boolean;

  /**
   * When CollectBuilding next becomes available for this building.
   *
   * UNSET MEANS "NOT COLLECTABLE" — never "ready now". A collectable building
   * always carries a real timestamp, which is in the past when it is ready to
   * collect right now (a building never collected reports the instant it was
   * claimed). Unset means the caller is not the owner, the building is a
   * safehouse, or the lifecycle is switched off.
   *
   * Clients must therefore gate the collect affordance on the field being
   * PRESENT AND in the past, not merely on the comparison — treating unset as
   * "ready now" shows an enabled button that the server refuses, which is
   * exactly the bug this wording replaced. Same contract as next_tier_cost
   * below, where 0 means "no upgrade available".
   *
   * @generated from field: optional int64 collect_ready_at_unix_ms = 22;
   */
  collectReadyAtUnixMs?: bigint | undefined;

  /**
   * Deadline of an arson takeover currently running against this building.
   *
   * SENT TO THE TWO PARTIES ONLY: the attacker who started the challenge and
   * the owner defending it. Both need the same clock — the attacker to know
   * how long they must hold, the owner to know whether the trip across town is
   * worth making. For a bystander it is left unset; the status still flips to
   * BUILDING_STATUS_CHALLENGED, so anyone can see the building is contested,
   * but only the two players in the race get the countdown. That is why this
   * field is optional rather than a plain int64.
   *
   * (It was attacker-only at first, on the theory that a defender who knew the
   * deadline would arrive one second before it. What that produced was an
   * owner who could not reason about their own building at all, so the clock is
   * now shared and the race is the mechanic.)
   *
   * Who-sees-what is applied in the handler when it builds the response, not
   * here — the proto cannot express "only for these callers". Anything that
   * constructs a BuildingInfo has to reapply it.
   *
   * @generated from field: optional int64 challenge_ends_at_unix_ms = 23;
   */
  challengeEndsAtUnixMs?: bigint | undefined;

  /**
   * When a BUILDING_STATUS_DESTROYED building comes back as unclaimed and is
   * available to be taken again. Unset unless the building is destroyed.
   *
   * @generated from field: optional int64 rebuild_at_unix_ms = 24;
   */
  rebuildAtUnixMs?: bigint | undefined;

  /**
   * Dirty cash UpgradeBuilding will charge to take this building to the next
   * tier. Zero at max tier, which is also how a client should decide to hide
   * the upgrade affordance rather than hardcoding the tier ceiling.
   *
   * @generated from field: int64 next_tier_cost = 25;
   */
  nextTierCost: bigint;

  /**
   * What this building's rung is worth today, and what next_tier_cost buys —
   * so a client can say what an upgrade DOES rather than only what it costs.
   *
   * Owner-only, set by the same branch as next_tier_cost, and set as a PAIR
   * exactly when next_tier_cost > 0. That coupling is deliberate: the two
   * fields describe a purchase, and there is no purchase to describe at max
   * tier or while the lifecycle is switched off. A client that shows the
   * upgrade control off next_tier_cost therefore always has both halves of
   * the before/after, and never has to guess one of them.
   *
   * @generated from field: optional building.v1.TierBenefits current_tier_benefits = 26;
   */
  currentTierBenefits?: TierBenefits | undefined;

  /**
   * @generated from field: optional building.v1.TierBenefits next_tier_benefits = 27;
   */
  nextTierBenefits?: TierBenefits | undefined;

  /**
   * What one CollectBuilding actually pays out of this building today, gross —
   * base_reward already scaled by the rung the building stands on. This is the
   * number a client should print as the building's income.
   *
   * base_reward above is the TYPE's figure and does not move when a building is
   * upgraded, which is precisely the bug this field exists to close: a player
   * who paid for tier 2 watched the dossier and the holdings list go on
   * reporting the tier 1 take, while the server quietly paid 175% of it. The
   * client cannot fix that by multiplying, because the ladder is operator
   * tunable and current_tier_benefits is owner-only and is deliberately unset
   * at max tier — so the one caller who most needs the number would be the one
   * without it. The server does the arithmetic and ships the answer.
   *
   * Public, like base_reward and tier: it is derived from two fields every
   * viewer already has, so masking it would protect nothing.
   *
   * Zero means the building earns nothing — no row in building_type_attributes
   * (a safehouse, a hospital) — and is the same answer base_reward gives. With
   * the lifecycle switched off this reports base_reward UNSCALED, because that
   * is what the nightly revenue tick pays while nothing can call Collect; see
   * jobs/revenue_tick, which chooses the legacy full-rate statement on exactly
   * the same flag.
   *
   * @generated from field: int64 tier_income = 28;
   */
  tierIncome: bigint;
};

/**
 * Describes the message building.v1.BuildingInfo.
 * Use `create(BuildingInfoSchema)` to create a new message.
 */
export const BuildingInfoSchema: GenMessage<BuildingInfo> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 3);

/**
 * What one rung of the tier ladder is worth.
 *
 * Percentages exactly as building_config stores them, so the client renders
 * what the server will actually apply: income_mult_pct scales base_reward
 * (100 = unchanged, 175 = +75%), while the other two are a reduction and a
 * bonus against their own baselines (0 = none).
 *
 * This exists so the tier ladder lives in ONE place. The numbers are operator
 * tunable from the Backroom, and a client holding its own copy would keep
 * promising last season's multipliers — which is why BuildingInfo advertises
 * them per building rather than exposing a config endpoint to be cached.
 *
 * @generated from message building.v1.TierBenefits
 */
export type TierBenefits = Message<"building.v1.TierBenefits"> & {
  /**
   * @generated from field: int32 tier = 1;
   */
  tier: number;

  /**
   * @generated from field: int32 income_mult_pct = 2;
   */
  incomeMultPct: number;

  /**
   * @generated from field: int32 decay_reduction_pct = 3;
   */
  decayReductionPct: number;

  /**
   * @generated from field: int32 challenge_bonus_pct = 4;
   */
  challengeBonusPct: number;
};

/**
 * Describes the message building.v1.TierBenefits.
 * Use `create(TierBenefitsSchema)` to create a new message.
 */
export const TierBenefitsSchema: GenMessage<TierBenefits> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 4);

/**
 * @generated from message building.v1.ListNearbyBuildingsRequest
 */
export type ListNearbyBuildingsRequest = Message<"building.v1.ListNearbyBuildingsRequest"> & {
  /**
   * @generated from field: double latitude = 1;
   */
  latitude: number;

  /**
   * @generated from field: double longitude = 2;
   */
  longitude: number;

  /**
   * @generated from field: double radius_m = 3;
   */
  radiusM: number;
};

/**
 * Describes the message building.v1.ListNearbyBuildingsRequest.
 * Use `create(ListNearbyBuildingsRequestSchema)` to create a new message.
 */
export const ListNearbyBuildingsRequestSchema: GenMessage<ListNearbyBuildingsRequest> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 5);

/**
 * @generated from message building.v1.ListNearbyBuildingsResponse
 */
export type ListNearbyBuildingsResponse = Message<"building.v1.ListNearbyBuildingsResponse"> & {
  /**
   * @generated from field: repeated building.v1.BuildingInfo buildings = 1;
   */
  buildings: BuildingInfo[];
};

/**
 * Describes the message building.v1.ListNearbyBuildingsResponse.
 * Use `create(ListNearbyBuildingsResponseSchema)` to create a new message.
 */
export const ListNearbyBuildingsResponseSchema: GenMessage<ListNearbyBuildingsResponse> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 6);

/**
 * @generated from message building.v1.ListPlayerBuildingsRequest
 */
export type ListPlayerBuildingsRequest = Message<"building.v1.ListPlayerBuildingsRequest"> & {
  /**
   * Exactly one of these selects the ownership filter. If both are empty the
   * server falls back to the caller's own player_id from the auth context.
   *
   * @generated from oneof building.v1.ListPlayerBuildingsRequest.owner
   */
  owner: {
    /**
     * @generated from field: string player_id = 1;
     */
    value: string;
    case: "playerId";
  } | {
    /**
     * @generated from field: string faction = 2;
     */
    value: string;
    case: "faction";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message building.v1.ListPlayerBuildingsRequest.
 * Use `create(ListPlayerBuildingsRequestSchema)` to create a new message.
 */
export const ListPlayerBuildingsRequestSchema: GenMessage<ListPlayerBuildingsRequest> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 7);

/**
 * @generated from message building.v1.ListPlayerBuildingsResponse
 */
export type ListPlayerBuildingsResponse = Message<"building.v1.ListPlayerBuildingsResponse"> & {
  /**
   * @generated from field: repeated building.v1.BuildingInfo buildings = 1;
   */
  buildings: BuildingInfo[];
};

/**
 * Describes the message building.v1.ListPlayerBuildingsResponse.
 * Use `create(ListPlayerBuildingsResponseSchema)` to create a new message.
 */
export const ListPlayerBuildingsResponseSchema: GenMessage<ListPlayerBuildingsResponse> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 8);

/**
 * @generated from message building.v1.UpgradeBuildingRequest
 */
export type UpgradeBuildingRequest = Message<"building.v1.UpgradeBuildingRequest"> & {
  /**
   * @generated from field: string building_id = 1;
   */
  buildingId: string;

  /**
   * @generated from field: string player_id = 2;
   */
  playerId: string;
};

/**
 * Describes the message building.v1.UpgradeBuildingRequest.
 * Use `create(UpgradeBuildingRequestSchema)` to create a new message.
 */
export const UpgradeBuildingRequestSchema: GenMessage<UpgradeBuildingRequest> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 9);

/**
 * @generated from message building.v1.UpgradeBuildingResponse
 */
export type UpgradeBuildingResponse = Message<"building.v1.UpgradeBuildingResponse"> & {
  /**
   * @generated from field: building.v1.BuildingInfo building = 1;
   */
  building?: BuildingInfo | undefined;

  /**
   * @generated from field: int64 cost_dirty_cash = 2;
   */
  costDirtyCash: bigint;
};

/**
 * Describes the message building.v1.UpgradeBuildingResponse.
 * Use `create(UpgradeBuildingResponseSchema)` to create a new message.
 */
export const UpgradeBuildingResponseSchema: GenMessage<UpgradeBuildingResponse> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 10);

/**
 * CollectBuilding takes only the target: the collector is the authenticated
 * caller and their position comes from the server-cached GPS fix, so neither
 * is client-supplied.
 *
 * @generated from message building.v1.CollectBuildingRequest
 */
export type CollectBuildingRequest = Message<"building.v1.CollectBuildingRequest"> & {
  /**
   * @generated from field: string building_id = 1;
   */
  buildingId: string;
};

/**
 * Describes the message building.v1.CollectBuildingRequest.
 * Use `create(CollectBuildingRequestSchema)` to create a new message.
 */
export const CollectBuildingRequestSchema: GenMessage<CollectBuildingRequest> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 11);

/**
 * @generated from message building.v1.CollectBuildingResponse
 */
export type CollectBuildingResponse = Message<"building.v1.CollectBuildingResponse"> & {
  /**
   * @generated from field: building.v1.BuildingInfo building = 1;
   */
  building?: BuildingInfo | undefined;

  /**
   * NET credited, after the family skim
   *
   * @generated from field: int64 amount_collected = 2;
   */
  amountCollected: bigint;

  /**
   * balance after the payout
   *
   * @generated from field: int64 player_dirty_cash = 3;
   */
  playerDirtyCash: bigint;

  /**
   * start of the next 24h window
   *
   * @generated from field: int64 next_collect_at_unix_ms = 4;
   */
  nextCollectAtUnixMs: bigint;
};

/**
 * Describes the message building.v1.CollectBuildingResponse.
 * Use `create(CollectBuildingResponseSchema)` to create a new message.
 */
export const CollectBuildingResponseSchema: GenMessage<CollectBuildingResponse> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 12);

/**
 * DefendBuilding likewise takes only the target; the defender is the
 * authenticated caller and must be the owner.
 *
 * @generated from message building.v1.DefendBuildingRequest
 */
export type DefendBuildingRequest = Message<"building.v1.DefendBuildingRequest"> & {
  /**
   * @generated from field: string building_id = 1;
   */
  buildingId: string;
};

/**
 * Describes the message building.v1.DefendBuildingRequest.
 * Use `create(DefendBuildingRequestSchema)` to create a new message.
 */
export const DefendBuildingRequestSchema: GenMessage<DefendBuildingRequest> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 13);

/**
 * @generated from message building.v1.DefendBuildingResponse
 */
export type DefendBuildingResponse = Message<"building.v1.DefendBuildingResponse"> & {
  /**
   * @generated from field: building.v1.BuildingInfo building = 1;
   */
  building?: BuildingInfo | undefined;

  /**
   * size of the defence encounter
   *
   * @generated from field: int32 raiders_spawned = 2;
   */
  raidersSpawned: number;

  /**
   * when the encounter expires unfought
   *
   * @generated from field: int64 defence_ends_at_unix_ms = 3;
   */
  defenceEndsAtUnixMs: bigint;
};

/**
 * Describes the message building.v1.DefendBuildingResponse.
 * Use `create(DefendBuildingResponseSchema)` to create a new message.
 */
export const DefendBuildingResponseSchema: GenMessage<DefendBuildingResponse> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 14);

/**
 * BuildSafehouse is empty: position (server-cached GPS) and identity (auth
 * context) are not client-supplied.
 *
 * @generated from message building.v1.BuildSafehouseRequest
 */
export type BuildSafehouseRequest = Message<"building.v1.BuildSafehouseRequest"> & {
};

/**
 * Describes the message building.v1.BuildSafehouseRequest.
 * Use `create(BuildSafehouseRequestSchema)` to create a new message.
 */
export const BuildSafehouseRequestSchema: GenMessage<BuildSafehouseRequest> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 15);

/**
 * @generated from message building.v1.BuildSafehouseResponse
 */
export type BuildSafehouseResponse = Message<"building.v1.BuildSafehouseResponse"> & {
  /**
   * @generated from field: building.v1.BuildingInfo building = 1;
   */
  building?: BuildingInfo | undefined;

  /**
   * balance after the 50k build charge
   *
   * @generated from field: int64 player_dirty_cash = 2;
   */
  playerDirtyCash: bigint;
};

/**
 * Describes the message building.v1.BuildSafehouseResponse.
 * Use `create(BuildSafehouseResponseSchema)` to create a new message.
 */
export const BuildSafehouseResponseSchema: GenMessage<BuildSafehouseResponse> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 16);

/**
 * UpgradeSafehouse is empty: the caller's unique safehouse is resolved from
 * the auth context.
 *
 * @generated from message building.v1.UpgradeSafehouseRequest
 */
export type UpgradeSafehouseRequest = Message<"building.v1.UpgradeSafehouseRequest"> & {
};

/**
 * Describes the message building.v1.UpgradeSafehouseRequest.
 * Use `create(UpgradeSafehouseRequestSchema)` to create a new message.
 */
export const UpgradeSafehouseRequestSchema: GenMessage<UpgradeSafehouseRequest> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 17);

/**
 * @generated from message building.v1.UpgradeSafehouseResponse
 */
export type UpgradeSafehouseResponse = Message<"building.v1.UpgradeSafehouseResponse"> & {
  /**
   * @generated from field: building.v1.BuildingInfo building = 1;
   */
  building?: BuildingInfo | undefined;

  /**
   * full listed price of the new tier
   *
   * @generated from field: int64 cost_dirty_cash = 2;
   */
  costDirtyCash: bigint;

  /**
   * balance after the upgrade charge
   *
   * @generated from field: int64 player_dirty_cash = 3;
   */
  playerDirtyCash: bigint;
};

/**
 * Describes the message building.v1.UpgradeSafehouseResponse.
 * Use `create(UpgradeSafehouseResponseSchema)` to create a new message.
 */
export const UpgradeSafehouseResponseSchema: GenMessage<UpgradeSafehouseResponse> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 18);

/**
 * @generated from message building.v1.BombBuildingRequest
 */
export type BombBuildingRequest = Message<"building.v1.BombBuildingRequest"> & {
  /**
   * @generated from field: string building_id = 1;
   */
  buildingId: string;
};

/**
 * Describes the message building.v1.BombBuildingRequest.
 * Use `create(BombBuildingRequestSchema)` to create a new message.
 */
export const BombBuildingRequestSchema: GenMessage<BombBuildingRequest> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 19);

/**
 * @generated from message building.v1.ArsonBuildingRequest
 */
export type ArsonBuildingRequest = Message<"building.v1.ArsonBuildingRequest"> & {
  /**
   * @generated from field: string building_id = 1;
   */
  buildingId: string;
};

/**
 * Describes the message building.v1.ArsonBuildingRequest.
 * Use `create(ArsonBuildingRequestSchema)` to create a new message.
 */
export const ArsonBuildingRequestSchema: GenMessage<ArsonBuildingRequest> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 20);

/**
 * @generated from message building.v1.IntimidateBuildingRequest
 */
export type IntimidateBuildingRequest = Message<"building.v1.IntimidateBuildingRequest"> & {
  /**
   * @generated from field: string building_id = 1;
   */
  buildingId: string;
};

/**
 * Describes the message building.v1.IntimidateBuildingRequest.
 * Use `create(IntimidateBuildingRequestSchema)` to create a new message.
 */
export const IntimidateBuildingRequestSchema: GenMessage<IntimidateBuildingRequest> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 21);

/**
 * BuildingActionResponse is the common response shape for Bomb/Arson/Intimidate.
 * It returns the updated building alongside the acting player's new state.
 *
 * @generated from message building.v1.BuildingActionResponse
 */
export type BuildingActionResponse = Message<"building.v1.BuildingActionResponse"> & {
  /**
   * @generated from field: building.v1.BuildingInfo building = 1;
   */
  building?: BuildingInfo | undefined;

  /**
   * @generated from field: int64 player_dirty_cash = 2;
   */
  playerDirtyCash: bigint;

  /**
   * @generated from field: int64 player_clean_influence = 3;
   */
  playerCleanInfluence: bigint;

  /**
   * @generated from field: int32 player_heat = 4;
   */
  playerHeat: number;
};

/**
 * Describes the message building.v1.BuildingActionResponse.
 * Use `create(BuildingActionResponseSchema)` to create a new message.
 */
export const BuildingActionResponseSchema: GenMessage<BuildingActionResponse> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 22);

/**
 * @generated from message building.v1.VisitBuildingRequest
 */
export type VisitBuildingRequest = Message<"building.v1.VisitBuildingRequest"> & {
  /**
   * @generated from field: string building_id = 1;
   */
  buildingId: string;
};

/**
 * Describes the message building.v1.VisitBuildingRequest.
 * Use `create(VisitBuildingRequestSchema)` to create a new message.
 */
export const VisitBuildingRequestSchema: GenMessage<VisitBuildingRequest> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 23);

/**
 * @generated from message building.v1.VisitBuildingResponse
 */
export type VisitBuildingResponse = Message<"building.v1.VisitBuildingResponse"> & {
  /**
   * True when the caller was within interaction range and the visit
   * counted toward any active visit_building objectives.
   *
   * @generated from field: bool in_range = 1;
   */
  inRange: boolean;
};

/**
 * Describes the message building.v1.VisitBuildingResponse.
 * Use `create(VisitBuildingResponseSchema)` to create a new message.
 */
export const VisitBuildingResponseSchema: GenMessage<VisitBuildingResponse> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 24);

/**
 * @generated from message building.v1.GetPublicConfigRequest
 */
export type GetPublicConfigRequest = Message<"building.v1.GetPublicConfigRequest"> & {
};

/**
 * Describes the message building.v1.GetPublicConfigRequest.
 * Use `create(GetPublicConfigRequestSchema)` to create a new message.
 */
export const GetPublicConfigRequestSchema: GenMessage<GetPublicConfigRequest> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 25);

/**
 * PublicConfig is the read-only projection of interaction_config the client is
 * allowed to see. Server-owned bounds only — nothing here is a request the
 * client can make, and the server re-checks every value on every action
 * regardless of what the client believes.
 *
 * @generated from message building.v1.PublicConfig
 */
export type PublicConfig = Message<"building.v1.PublicConfig"> & {
  /**
   * How close (metres) the player must be standing to act on a building,
   * take a job from a giver, pick up loot, or use their safehouse stash.
   *
   * Metres, not world units: Mapbox world distance scales with the map's
   * zoom, so a world-unit radius is not a distance anyone can walk. The
   * client converts with a haversine against its own GPS fix.
   *
   * @generated from field: int32 interaction_radius_m = 1;
   */
  interactionRadiusM: number;

  /**
   * How far apart two players may stand and still trade. Its own field
   * because it is its own rule — see interaction_config (migration 059).
   *
   * @generated from field: int32 trade_sitdown_m = 2;
   */
  tradeSitdownM: number;

  /**
   * What share (percent) of a building's income the nightly catch-up tick
   * pays on holdings nobody came and collected in person —
   * building_config.collect_catchup_pct, 25 by default.
   *
   * The client needs it to say what a portfolio actually EARNS. Summing
   * tier_income over the holdings gives the full-price figure, which is what
   * walking to every building and tapping Collect would pay; a player who
   * never visits banks this fraction of it. Rendering only the former is how
   * MafiaGo#232 happened: a "daily income" of $24,750 over a wallet that moved
   * $5,253, with nothing on screen to reconcile the two.
   *
   * Operator-tunable and server-owned, exactly like the interaction radius
   * above, and told to the client the same way rather than hardcoded: a
   * constant in the app would silently start lying the first time an operator
   * moved the rate in the Backroom.
   *
   * 100 means there is no shortfall to explain: the lifecycle kill switch is
   * off, so Collect does not exist and the tick pays the full sum — see the
   * header of jobs/revenue_tick.
   *
   * ZERO MEANS "NOTHING TO REPORT", and it has to, because a proto3 scalar
   * cannot tell a server that set 0 from one too old to know the field at all.
   * A client reading 0 draws no passive figure rather than announcing that the
   * player earns nothing, since the far likelier cause is an older server. An
   * operator who genuinely wants no passive income turns the catch-up down to
   * a rate that still renders, or the lifecycle flag off — both of which say
   * so unambiguously.
   *
   * @generated from field: int32 collect_catchup_pct = 3;
   */
  collectCatchupPct: number;
};

/**
 * Describes the message building.v1.PublicConfig.
 * Use `create(PublicConfigSchema)` to create a new message.
 */
export const PublicConfigSchema: GenMessage<PublicConfig> = /*@__PURE__*/
  messageDesc(file_building_v1_building, 26);

/**
 * @generated from enum building.v1.BuildingStatus
 */
export enum BuildingStatus {
  /**
   * @generated from enum value: BUILDING_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BUILDING_STATUS_UNCLAIMED = 1;
   */
  UNCLAIMED = 1,

  /**
   * @generated from enum value: BUILDING_STATUS_CLAIMED = 2;
   */
  CLAIMED = 2,

  /**
   * @generated from enum value: BUILDING_STATUS_DESTROYED = 3;
   */
  DESTROYED = 3,

  /**
   * @generated from enum value: BUILDING_STATUS_CHALLENGED = 4;
   */
  CHALLENGED = 4,
}

/**
 * Describes the enum building.v1.BuildingStatus.
 */
export const BuildingStatusSchema: GenEnum<BuildingStatus> = /*@__PURE__*/
  enumDesc(file_building_v1_building, 0);

/**
 * @generated from service building.v1.BuildingService
 */
export const BuildingService: GenService<{
  /**
   * @generated from rpc building.v1.BuildingService.ClaimBuilding
   */
  claimBuilding: {
    methodKind: "unary";
    input: typeof ClaimBuildingRequestSchema;
    output: typeof ClaimBuildingResponseSchema;
  },
  /**
   * @generated from rpc building.v1.BuildingService.GetBuilding
   */
  getBuilding: {
    methodKind: "unary";
    input: typeof GetBuildingRequestSchema;
    output: typeof BuildingInfoSchema;
  },
  /**
   * @generated from rpc building.v1.BuildingService.ListNearbyBuildings
   */
  listNearbyBuildings: {
    methodKind: "unary";
    input: typeof ListNearbyBuildingsRequestSchema;
    output: typeof ListNearbyBuildingsResponseSchema;
  },
  /**
   * ListPlayerBuildings returns every building owned by a player or by a
   * faction ("family"). Exactly one of owner.player_id or owner.faction must
   * be set; an empty owner defaults to the caller's own player_id.
   *
   * @generated from rpc building.v1.BuildingService.ListPlayerBuildings
   */
  listPlayerBuildings: {
    methodKind: "unary";
    input: typeof ListPlayerBuildingsRequestSchema;
    output: typeof ListPlayerBuildingsResponseSchema;
  },
  /**
   * UpgradeBuilding raises an owned building one tier, charged in dirty cash at
   * the price advertised as BuildingInfo.next_tier_cost. This shipped as a stub
   * returning Unimplemented for a long time and is now backed by a real
   * handler, so a client that special-cases that error is out of date.
   *
   * @generated from rpc building.v1.BuildingService.UpgradeBuilding
   */
  upgradeBuilding: {
    methodKind: "unary";
    input: typeof UpgradeBuildingRequestSchema;
    output: typeof UpgradeBuildingResponseSchema;
  },
  /**
   * CollectBuilding banks the daily income of a building the caller owns. The
   * owner has to physically be there — it is proximity-gated on the same
   * interaction range as VisitBuilding — and every building carries its own
   * 24h rolling cooldown, advertised ahead of time as
   * BuildingInfo.collect_ready_at_unix_ms. amount_collected is NET: the
   * family's skim comes off before the player is credited.
   *
   * This is deliberately the one-building, be-there-in-person path. The bulk
   * "collect everything without travelling" flow is
   * EconomyService.CollectRevenue in economy.proto, which is currently
   * unimplemented and is the intended future home for premium Remote
   * Collection. Do not grow that behaviour onto this RPC.
   *
   * @generated from rpc building.v1.BuildingService.CollectBuilding
   */
  collectBuilding: {
    methodKind: "unary";
    input: typeof CollectBuildingRequestSchema;
    output: typeof CollectBuildingResponseSchema;
  },
  /**
   * DefendBuilding is the owner's answer to an arson takeover. While a building
   * sits in BUILDING_STATUS_CHALLENGED the attacker has a claim running against
   * it; the owner travelling to the building and calling this spawns a defence
   * encounter — raiders that have to be fought off — rather than settling the
   * contest outright. Owner-only and proximity-gated.
   *
   * @generated from rpc building.v1.BuildingService.DefendBuilding
   */
  defendBuilding: {
    methodKind: "unary";
    input: typeof DefendBuildingRequestSchema;
    output: typeof DefendBuildingResponseSchema;
  },
  /**
   * BuildSafehouse creates the caller's one permanent safehouse (a synthetic
   * building, game_type "safehouse") at their current server-cached GPS
   * position. Gated: level >= 5, no existing safehouse, dirty_cash >= build
   * cost. Position and identity come from the auth context — the request is
   * empty by design.
   *
   * @generated from rpc building.v1.BuildingService.BuildSafehouse
   */
  buildSafehouse: {
    methodKind: "unary";
    input: typeof BuildSafehouseRequestSchema;
    output: typeof BuildSafehouseResponseSchema;
  },
  /**
   * UpgradeSafehouse advances the caller's safehouse one tier (Garage → Shop →
   * Crime Mansion) for the full listed price, paid in dirty cash. Requires the
   * caller to be near their safehouse. The safehouse is resolved from the auth
   * context, so the request is empty.
   *
   * @generated from rpc building.v1.BuildingService.UpgradeSafehouse
   */
  upgradeSafehouse: {
    methodKind: "unary";
    input: typeof UpgradeSafehouseRequestSchema;
    output: typeof UpgradeSafehouseResponseSchema;
  },
  /**
   * Hostile actions. player identity is taken from the auth context; the
   * request carries only the target building_id.
   *
   * @generated from rpc building.v1.BuildingService.BombBuilding
   */
  bombBuilding: {
    methodKind: "unary";
    input: typeof BombBuildingRequestSchema;
    output: typeof BuildingActionResponseSchema;
  },
  /**
   * @generated from rpc building.v1.BuildingService.ArsonBuilding
   */
  arsonBuilding: {
    methodKind: "unary";
    input: typeof ArsonBuildingRequestSchema;
    output: typeof BuildingActionResponseSchema;
  },
  /**
   * @generated from rpc building.v1.BuildingService.IntimidateBuilding
   */
  intimidateBuilding: {
    methodKind: "unary";
    input: typeof IntimidateBuildingRequestSchema;
    output: typeof BuildingActionResponseSchema;
  },
  /**
   * VisitBuilding records a quest "visit": the client calls it whenever
   * the building details screen opens. The visit only counts (emits the
   * visit_building quest event) when the caller is within the standard
   * interaction range; the response always carries the range verdict so
   * the client can show a "get closer" hint from the same call. Never
   * errors on being out of range.
   *
   * @generated from rpc building.v1.BuildingService.VisitBuilding
   */
  visitBuilding: {
    methodKind: "unary";
    input: typeof VisitBuildingRequestSchema;
    output: typeof VisitBuildingResponseSchema;
  },
  /**
   * The tunables the client must not hardcode. Today that is the interaction
   * radius: how close the player has to be standing before any of the verbs
   * above will be accepted.
   *
   * The client needs it because it gates its own buttons. Before this RPC the
   * client carried its own fixed ring, and the two numbers drifted apart the
   * moment either side was retuned — a client ring tighter than the server's
   * hides actions the server would have allowed, and a looser one offers
   * actions the server then refuses. Neither failure says anything useful to
   * the player.
   *
   * Cheap and unauthenticated-safe by design: no player state, no per-caller
   * work, so the client can call it once at login and again on reconnect.
   *
   * @generated from rpc building.v1.BuildingService.GetPublicConfig
   */
  getPublicConfig: {
    methodKind: "unary";
    input: typeof GetPublicConfigRequestSchema;
    output: typeof PublicConfigSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_building_v1_building, 0);

